import { Component, OnInit } from '@angular/core';
import { KenyanInsurancePaymentsService } from 'src/app/services/transit/kenyan-insurance-payments.service';

@Component({
  selector: 'app-vehicles-pending-ke-ins-pmt',
  templateUrl: './vehicles-pending-ke-ins-pmt.component.html',
  styleUrls: ['./vehicles-pending-ke-ins-pmt.component.css']
})
export class VehiclesPendingKeInsPmtComponent implements OnInit{
  page: number = 1;
  count: number = 0;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  public warningMessage: string | null = null;
  vehicles: any[] = [];
  searchText: string = '';
  public isLoading: boolean = false;

  constructor(
    private kenyanInsurancePaymentsService:KenyanInsurancePaymentsService,
  ){}

  ngOnInit(): void {
    this.isLoading=true;
    this.fetchVehicles();
  }

  fetchVehicles():void{
    this.kenyanInsurancePaymentsService.getvehiclesPendingKenyanInsurancePayment()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.vehicles = response.data;
          this.isLoading=false;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.isLoading=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isLoading=false;
      }
    });
  }

  pageChangeEvent(event: number){
    this.page = event;
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
    this.page = 1; // Reset to page 1 after applying filter
  }
}
